import React, { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";

/**
 * <VehicleVoteButton vehicleId="…" />
 * Vote a build for "Build of the Month". POST /api/vehicles/{id}/vote is a toggle.
 */
export default function VehicleVoteButton({ vehicleId }) {
    const [votes, setVotes] = useState(null);
    const [voted, setVoted] = useState(false);
    const [busy, setBusy] = useState(false);
    const { user } = useAuth();
    const navigate = useNavigate();

    // We don't have a "did I already vote" endpoint yet; the toggle returns state.
    // Initial render shows a neutral "Vote" until the user clicks.

    async function toggle() {
        if (!user) return navigate("/login");
        setBusy(true);
        try {
            const { data } = await api.post(`/vehicles/${vehicleId}/vote`);
            setVotes(data.votes);
            setVoted(data.voted);
        } catch (e) {
            toast.error(formatApiError(e));
        } finally {
            setBusy(false);
        }
    }

    return (
        <button
            type="button"
            data-testid={`vehicle-vote-${vehicleId}`}
            onClick={toggle}
            disabled={busy}
            className="inline-flex items-center gap-1.5 chip"
            style={{
                background: voted ? "rgba(225,6,0,0.2)" : undefined,
                borderColor: voted ? "rgba(225,6,0,0.6)" : undefined,
                color: voted ? "#FF6E68" : undefined,
                textTransform: "uppercase",
                letterSpacing: "0.12em",
                fontSize: 10,
                fontWeight: 700,
            }}
        >
            <Crown className="w-3 h-3" />
            {voted ? "Voted" : "Vote for BOTM"}
            {votes != null && <span className="ml-1">· {votes}</span>}
        </button>
    );
}
